export const getTitle = (status, message) => {
  if (status === 'error') return message || 'Error al descargar elemento';
  if (status === 'success') return 'Elemento descargado';
  if (status === 'pending') return 'Preparando descarga ';
  if (status === 'preparing') return 'Preparando descarga ';
};
